import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Autosuggest from 'react-autosuggest';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import InputAdornment from '@mui/material/InputAdornment';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';


import IconButton from '@mui/material/IconButton';
import ResetIcon from '@mui/icons-material/Cancel';

import debounce from 'lodash/debounce';


const MinimalLength = 3;

const styles = {
    container: {
        flexGrow: 1,
        position: 'relative'
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 2,
        marginTop: 10,
        maxHeight: '300px',
        overflowY: 'auto',
        backgroundColor: '#fff',
        border: '1px solid #aaa'
    },
    suggestion: {
        display: 'block'
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none'
    }
};


class ArticleGestionSearch extends React.Component {
    state = {
        isLoading: false
    };


    handleChangeConcerne = (value) => {
        this.props.onChangeConcerne(value);
    }

    renderInput = inputProps => {
        const { classes, ref, disabled, onClickReset, ...other } = inputProps;
        const { isRequired, error, concerneCheckBox, concerne, label, variant, size, color } = this.props;
        
        let _label = "Article";
        if (label) {
            _label = label;
        }

        return (
            <TextField
                fullWidth
                required={isRequired}
                error={error !== undefined}
                label={_label}
                placeholder="Rechercher un article"
                helperText={error ? error.errorMsg : ''}
                InputLabelProps={{
                    shrink: true
                }}
                InputProps={{
                    inputRef: ref,
                    classes: {
                        input: classes.input
                    },
                    disabled,
                    endAdornment: disabled && <InputAdornment position={'end'}>
                        <IconButton onClick={onClickReset} size="large"><ResetIcon /></IconButton>
                    </InputAdornment >,
                    startAdornment: concerneCheckBox &&
                        (<InputAdornment position={'start'}>
                            <Tooltip title="Article concerné par le dossier après-vente" placement="left" disableFocusListener>
                                <Checkbox checked={concerne} onClick={e => this.handleChangeConcerne(!concerne)}>Concerné</Checkbox>
                            </Tooltip>
                        </InputAdornment>),
                    ...other
                }}
                variant={variant}
                size={size}
                color={color}
            />
        );
    }

                

    renderSuggestionsContainer(options) {
        const { containerProps, children } = options;

        return (
            <div {...containerProps} >
                {children}
            </div>
        );
    }

    handleSuggestionsFetchRequested = debounce(({ value }) => {
        if (value.length >= MinimalLength) {
            const { onSearch } = this.props;

            this.setState({
                isLoading: true
            });

            onSearch(value);

            this.setState({
                isLoading: false
            });
        }
    }, 300);

    handleSuggestionsClearRequested = () => {
        const { onClear } = this.props;
        onClear();
    };

    handleChange = (event, { newValue, method }) => {
        const { onChange } = this.props;

        onChange(newValue);
    };

    handleSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        const { onSuggestionSelected } = this.props;
        onSuggestionSelected(suggestion);
    }

    handleBlur = (event, { highlightedSuggestion }) => {
        const { onSuggestionSelected, selected } = this.props;

        if (!selected || !selected.reference || selected.reference === '') {
            onSuggestionSelected({});
        }
    };
    
    handleClickReset = () => {
        const { onChange } = this.props;
        onChange('');
    }

    getSuggestionValue = (suggestion) => {
        return suggestion.reference + " - " + suggestion.designation;
    }

    renderSuggestion(suggestion, { query, isHighlighted }) {
        return (
            <MenuItem selected={isHighlighted} component="div" >
                {suggestion.reference} - {suggestion.designation}
            </MenuItem>
        );
    }

    render() {
        const { classes, articlesGestion, selected } = this.props;
        
        return (
            <Autosuggest 
                theme={{
                    container: classes.container,
                    suggestionsContainerOpen: classes.suggestionsContainerOpen,
                    suggestionsList: classes.suggestionsList,
                    suggestion: classes.suggestion
                }}
                renderInputComponent={this.renderInput}
                suggestions={articlesGestion}
                onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                renderSuggestionsContainer={this.renderSuggestionsContainer}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                onSuggestionSelected={this.handleSuggestionSelected}
                inputProps={{
                    classes,
                    value: this.props.value,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    disabled: selected && selected.reference && selected.reference !== '',
                    onClickReset: this.handleClickReset
                }}
            />
        );
    }
}

ArticleGestionSearch.propTypes = {
    articlesGestion: PropTypes.array.isRequired,
    onSearch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onSuggestionSelected: PropTypes.func.isRequired,
    value: PropTypes.string,
    selected: PropTypes.object,
    

    variant: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
};

export default withStyles(styles)(ArticleGestionSearch);